import { useState } from 'react';
import { useContentManager } from '../../hooks/useContentManager';

export default function HomeAwardsGallery() {
  const { getContentItem } = useContentManager();
  const galleryItem = getContentItem('home', 'awards-gallery');
  const images: { image: string; caption?: string }[] = Array.isArray(galleryItem?.metadata?.images)
    ? (galleryItem!.metadata.images as any[])
        .map((it: any) => {
          if (typeof it === 'string') return { image: it };
          const image = it?.image || it?.url || it?.src || '';
          const caption = it?.caption || it?.text || '';
          return image ? { image, caption } : null;
        })
        .filter(Boolean) as { image: string; caption?: string }[]
    : [];

  const [index, setIndex] = useState(0);
  const next = () => setIndex((prev) => (prev + 1) % images.length);
  const prev = () => setIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-6">
        {images.length > 0 ? (
          <div className="relative max-w-6xl mx-auto">
            <div className="relative rounded-lg overflow-hidden bg-black" style={{ paddingTop: '56.25%' }}>
              <img
                src={images[index].image}
                alt={images[index].caption || 'Gallery'}
                className="absolute inset-0 w-full h-full object-contain"
              />
              {images[index].caption && (
                <div className="absolute bottom-4 left-4 bg-black/70 text-white px-3 py-1 rounded text-xs tracking-widest uppercase">
                  {images[index].caption}
                </div>
              )}
            </div>
            {images.length > 1 && (
              <>
                <button
                  onClick={prev}
                  className="absolute left-4 sm:left-6 md:left-8 lg:left-10 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full hover:bg-black/70 z-10"
                  aria-label="Previous image"
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button
                  onClick={next}
                  className="absolute right-16 sm:right-20 md:right-24 lg:right-28 xl:right-32 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full hover:bg-black/70 z-10"
                  aria-label="Next image"
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </>
            )}
          </div>
        ) : (
          <div className="w-full h-[400px] bg-gray-800 flex items-center justify-center text-gray-400">
            Gallery images are not set
          </div>
        )}
      </div>
    </section>
  );
}
